import * as fetchMock from 'fetch-mock';
import { url } from '../services/usersTracingPost';
import ResponseCreator from './helpers/responseCreator';

fetchMock.post(`end:${process.env.REACT_APP_API_PATH}/${url}`, () => {
  return new ResponseCreator().getResponse();
});
